import { IAutomationFilters } from './Automation';
import { IAutomationNode, IAutomationNodeFilters } from './AutomationNode';
import { IAutomationVariable } from './AutomationVariable';

export enum AutomationTriggerType {
  // Brief
  BRIEF_ACCEPTED = 'BRIEF_ACCEPTED',
  BRIEF_SENT = 'BRIEF_SENT',

  // Deliverable
  DELIVERABLE_COMPLETED = 'DELIVERABLE_COMPLETED',
  DELIVERABLE_SUBMITTED = 'DELIVERABLE_SUBMITTED',
  DELIVERABLE_REJECTED = 'DELIVERABLE_REJECTED',

  // Product
  PRODUCT_ORDER_DELIVERED = 'PRODUCT_ORDER_DELIVERED',
  PRODUCT_ORDER_REQUEST_SENT = 'PRODUCT_ORDER_REQUEST_SENT',

  // Program
  PROGRAM_APPLIED = 'PROGRAM_APPLIED',
  PROGRAM_INVITED = 'PROGRAM_INVITED',
  PROGRAM_REJECTED = 'PROGRAM_REJECTED',
  PROGRAM_APPLICANT_APPROVED = 'PROGRAM_APPLICANT_APPROVED',
  MEMBER_ADDED_TO_PROGRAM = 'MEMBER_ADDED_TO_PROGRAM',

  // Sales Tracking
  SALES_TRACKING_FIRST_CONVERSION = 'SALES_TRACKING_FIRST_CONVERSION',

  // For every conversion
  SALES_TRACKING_CONVERSION = 'SALES_TRACKING_CONVERSION',

  // For boost validation
  SALES_TRACKING_BOOST_VALIDATION = 'SALES_TRACKING_BOOST_VALIDATION',

  // For Sales tracking emails
  MEMBER_ADDED_TO_AN_OFFER = 'MEMBER_ADDED_TO_AN_OFFER',
  PAYOUT_TIER_UNLOCKED = 'PAYOUT_TIER_UNLOCKED',
  OFFER_REWARD_UNLOCKED = 'OFFER_REWARD_UNLOCKED',
}

// TODO(jb) refactor to be a union type of all possible trigger types
export interface IAutomationTrigger {
  id?: string;
  type: AutomationTriggerType;
  root?: IAutomationNode;
  metadata: IAutomationTriggerMetadata;
  variables: IAutomationVariable[];
}

export interface IAutomationTriggerMetadata { }

export interface IAutomationTriggerFilters {
  id?: string;
  type?: AutomationTriggerType;
  automation?: IAutomationFilters;
  root?: IAutomationNodeFilters;
}

// #region Brief Accepted
export interface IAutomationBriefAcceptedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.BRIEF_ACCEPTED;
}
// #endregion

// #region Brief Sent
export interface IAutomationBriefSentTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.BRIEF_SENT;
}
// #endregion

// #region Deliverable Completed
export interface IAutomationDeliverableCompletedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.DELIVERABLE_COMPLETED;
}
// #endregion

// #region Deliverable Submitted
export interface IAutomationDeliverableSubmittedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.DELIVERABLE_SUBMITTED;
}
// #endregion

// #region Deliverable Rejected
export interface IAutomationDeliverableRejectedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.DELIVERABLE_REJECTED;
}
// #endregion

// #region Product Order Delivered
export interface IAutomationProductOrderDeliveredTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.PRODUCT_ORDER_DELIVERED;
}
// #endregion

// #region Product Order Request Sent
export interface IAutomationProductOrderRequestSentTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.PRODUCT_ORDER_REQUEST_SENT;
}
// #endregion

// #region Program Applied
export interface IAutomationProgramAppliedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.PROGRAM_APPLIED;
}
// #endregion

// #region Program Invited
export interface IAutomationProgramInvitedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.PROGRAM_INVITED;
}
// #endregion

// #region Program Rejected
export interface IAutomationProgramRejectedTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.PROGRAM_REJECTED;
}
// #endregion

// #region Sales Tracking First Conversion
export interface IAutomationSalesTrackingFirstConversionTrigger extends IAutomationTrigger {
  type: AutomationTriggerType.SALES_TRACKING_FIRST_CONVERSION;
}
// #endregion
